/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { HexRow2FragmentDoc } from "./hex-row/HexRow2.generated";
import { UnknownHexRowFragmentDoc } from "./hex-row/UnknownHexRow.generated";
export type CollectionHexLink2Fragment = {
  readonly __typename: "CollectionHexLink";
  readonly id: c.CollectionHexLinkId;
  readonly projectRole: Types.ProjectRole | null;
  readonly safeOrUnknownHex:
    | {
        readonly __typename: "Hex";
        readonly id: c.HexId;
        readonly title: string;
        readonly description: c.RichTextDocument | null;
        readonly canShare: boolean;
        readonly canSetOwner: boolean;
        readonly maxGrantableRole: Types.ProjectRole | null;
        readonly canViewLogic: boolean;
        readonly effectiveRole: Types.ProjectRole | null;
        readonly trashDate: c.DateTimeString | null;
        readonly starredByViewer: boolean;
        readonly userUpdatedDate: c.DateTimeString;
        readonly hexType: Types.HexType;
        readonly lastViewedByMe: c.DateTimeString | null;
        readonly requiresReview: boolean;
        readonly resolvedRequiresReview: boolean;
        readonly hasEnabledSchedules: boolean;
        readonly allowEmbedding: boolean;
        readonly canDelete: boolean;
        readonly canEditMetadata: boolean;
        readonly canUseApp: boolean;
        readonly projectLanguage: Types.ProjectLanguage;
        readonly canEdit: boolean;
        readonly canEditorsShare: boolean;
        readonly archivedDate: c.DateTimeString | null;
        readonly unarchivedDate: c.DateTimeString | null;
        readonly publicRoleV2: Types.ProjectRole | null;
        readonly organizationRoleV2: Types.ProjectRole | null;
        readonly grantSummary: c.ProjectGrantSummary;
        readonly onlyGrantedToCurrentUser: boolean;
        readonly totalViewCount: number;
        readonly dateCreated: c.DateTimeString;
        readonly status: {
          readonly __typename: "Status";
          readonly enforcesReview: boolean;
          readonly id: c.StatusId;
          readonly name: string;
          readonly color: Types.HexColor;
          readonly description: string | null;
          readonly inLibrary: boolean;
          readonly endorsed: boolean;
          readonly icon: Types.IconType | null;
        } | null;
        readonly categories: ReadonlyArray<{
          readonly __typename: "Category";
          readonly id: c.CategoryId;
          readonly name: string;
          readonly color: Types.HexColor;
          readonly description: string | null;
        }>;
        readonly lastPublishedVersion: {
          readonly __typename: "HexVersion";
          readonly id: c.HexVersionId;
          readonly screenshotUrls: c.ScreenshotUrls | null;
          readonly dateCreated: c.DateTimeString;
          readonly denialReason:
            | {
                readonly __typename: "AssetAccess";
                readonly hasAccessToSharedDataConnections: boolean;
                readonly hasAccessToSharedFiles: boolean;
                readonly hasAccessToSharedPackages: boolean;
                readonly hasAccessToSharedSecrets: boolean;
                readonly hasAccessToSharedSyncRepositories: boolean;
              }
            | { readonly __typename: "MissingProjectRole" }
            | null;
        } | null;
        readonly currentDraft: {
          readonly __typename: "HexVersion";
          readonly createdDate: c.DateTimeString;
          readonly id: c.HexVersionId;
          readonly title: string;
          readonly logicSessionId: c.AppSessionId;
          readonly canEdit: boolean;
          readonly kernelImage: c.KernelImage;
          readonly kernelSize: c.KernelSize;
          readonly kernelSizeHumanName: string | null;
          readonly kernelImageHumanName: string | null;
          readonly oAuthSettings: {
            readonly __typename: "HexVersionOAuthSettings";
            readonly id: c.HexVersionOAuthSettingsId;
            readonly logicViewTokenShared: boolean;
          } | null;
          readonly denialReason:
            | {
                readonly __typename: "AssetAccess";
                readonly hasAccessToSharedDataConnections: boolean;
                readonly hasAccessToSharedFiles: boolean;
                readonly hasAccessToSharedPackages: boolean;
                readonly hasAccessToSharedSecrets: boolean;
                readonly hasAccessToSharedSyncRepositories: boolean;
              }
            | { readonly __typename: "MissingProjectRole" }
            | null;
        };
        readonly owner: {
          readonly __typename: "User";
          readonly id: c.UserId;
          readonly name: string | null;
          readonly email: string;
          readonly imageUrl?: string | null;
        };
        readonly creator: {
          readonly __typename: "User";
          readonly id: c.UserId;
          readonly name: string | null;
          readonly email: string;
          readonly imageUrl?: string | null;
        };
        readonly collectionHexLink: {
          readonly __typename: "CollectionHexLink";
          readonly id: c.CollectionHexLinkId;
          readonly projectRole: Types.ProjectRole | null;
          readonly collection: {
            readonly __typename: "Collection";
            readonly id: c.CollectionId;
          };
        } | null;
        readonly safeCollectionHexLinks: ReadonlyArray<{
          readonly __typename: "CollectionHexLink";
          readonly id: c.CollectionHexLinkId;
          readonly collection: {
            readonly __typename: "Collection";
            readonly id: c.CollectionId;
            readonly name: string;
            readonly emoji: string | null;
          };
        }>;
        readonly org: {
          readonly __typename: "Org";
          readonly id: c.OrgId;
          readonly displayName: string;
          readonly allowPublicSharing: boolean;
          readonly resolvedAllowPublicSharing: boolean;
        };
        readonly projectAnalytics: {
          readonly __typename: "HexAnalytics";
          readonly id: c.HexAnalyticsId;
          readonly totalViewsLast7Days: number;
          readonly totalViewsLast14Days: number;
          readonly totalViewsLast30Days: number;
          readonly lastPublishedViewedDate: c.DateTimeString | null;
        };
      }
    | {
        readonly __typename: "UnknownHex";
        readonly id: c.HexId;
        readonly userUpdatedDate: c.DateTimeString;
        readonly hexType: Types.HexType;
        readonly creator: {
          readonly __typename: "User";
          readonly id: c.UserId;
          readonly name: string | null;
          readonly email: string;
        };
        readonly owner: {
          readonly __typename: "User";
          readonly id: c.UserId;
          readonly name: string | null;
          readonly email: string;
        };
      };
  readonly collection: {
    readonly __typename: "Collection";
    readonly id: c.CollectionId;
  };
};

export const CollectionHexLink2FragmentDoc = /*#__PURE__*/ gql`
  fragment CollectionHexLink2Fragment on CollectionHexLink {
    id
    projectRole
    safeOrUnknownHex {
      ... on Hex {
        ...HexRow2Fragment
      }
      ... on UnknownHex {
        ...UnknownHexRowFragment
      }
    }
    collection {
      id
    }
  }
  ${HexRow2FragmentDoc}
  ${UnknownHexRowFragmentDoc}
`;
